import { useEffect } from 'react';

export const useTitleHook = (title?: string | null) => {
  const siteName = 'Solution 2.0'
  useEffect(() => {
    document.title = `${title ? title : '...'} | ${siteName} `;
  }, [title]);
}
